module.exports = "<div id=\"transition-dash\" class=\"hide\">\r\n    <div class=\"mask\">\r\n        <div class=\"text\"></div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./fk.app/_src/transitions/transition-dash.html
// module id = 21
// module chunks = 0